import { render } from "./SearchSelectClientecitas.vue?vue&type=template&id=6db6bf28"
import script from "./SearchSelectClientecitas.vue?vue&type=script&lang=js"
export * from "./SearchSelectClientecitas.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__